import { AssessmentQuestionnaires, Questionnaires } from "../enums/questionnaires";

/**
 * Canonical urls of the PRACTICE_DEPENDENT seed Questionnaires: Client Intake and the assessments.
 * Each practice holds its own copy under the same url, so responses carry the url as their
 * identifier and one Subscription per type in medplum.subscription.json can match every practice.
 * A sync test keeps this set equal to the tagged seeds.
 */
export const PRACTICE_QUESTIONNAIRE_URLS: ReadonlySet<string> = new Set<string>([
  Questionnaires.ClientIntake,
  ...Object.values(AssessmentQuestionnaires),
]);
